import { useEffect } from "react";
import { scope } from "../environments";
import { getData } from "../utils/APIUtilities";
import ModalLoadingFull from "../utils/ModalLoadingFull";
import { postNotification } from "../utils/Notifications";
import { urlParams } from "../utils/urlParams";
import { getEnvironmentVariable } from "../global/environmentVariables";

const storedClientId = sessionStorage?.getItem("client_id");
const AUTH_CLIENT_ID = getEnvironmentVariable("AUTH_CLIENT_ID") || "web-app";

export default function OICAutoLink() {
  const { client_id, identity_provider, username } = urlParams();
  const scopes = scope(client_id || storedClientId || AUTH_CLIENT_ID);
  const _scope = scopes?.filter(
    (s) =>
      s.amplify?.identity_provider?.trim()?.toUpperCase() ===
      identity_provider?.trim()?.toUpperCase(),
  )[0]?.amplify;

  useEffect(() => {
    const process = async () => {
      try {
        if (!client_id) {
          throw new Error("missing client_id parameter");
        }
        if (!identity_provider) {
          throw new Error("missing identity_provider parameter");
        }
        if (!_scope?.responseType) {
          throw new Error("scope missing responseType parameter");
        }
        if (!_scope?.scope) {
          throw new Error("missing scope parameter");
        }

        if (username) {
          localStorage.setItem("oic_link_username", username);
        }

        const url = await getData("/users/oicurl", {
          queryStringParameters: {
            provider: _scope.identity_provider,
            redirect_uri: `https://${window.location.host}/oauth2/idpresponse`,
            responseType: _scope.responseType.toUpperCase(),
            scope: _scope.scope.join(" "),
          },
        });

        window.location.assign(url);
      } catch (err) {
        console.error(err);
        postNotification("error", err);
      }
    };

    process();

    // eslint-disable-next-line
  }, []);

  return <ModalLoadingFull />;
}
